/* eslint-disable camelcase */
type User = {
  email: string;
  title: string;
  name: string;
  university_code: string;
  advisor: string;
  cmkl_id: string;
  first_name: string;
  first_term: string;
  id: string;
  program_id: string;
  programs: any;
  last_name: string;
  last_term: string;
  nickname: string;
  role: number;
  roles: Array<Role>;
  cie_dual_degree: boolean;
};
export type Role = {
  role_id: string;
  role: number;
}
// export const DummyUser: User = {
//   name: 'Visarut',
//   lastname: 'Techatanachai
//   picture: 'https://picsum.photos/200',
// };

export const EmptyUser: User = {
  email: '',
  title: '',
  name: '',
  university_code: '',
  advisor: '',
  cmkl_id: '',
  first_name: '',
  first_term: '',
  id: '',
  program_id: '',
  programs: [],
  last_name: '',
  last_term: '',
  nickname: '',
  role: 0,
  roles: [],
  cie_dual_degree: false
};

export default User;
